import React, { useState } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import classNames from 'classnames';
import { getMe, userQuerySettings } from '../../../queries/user';
import { getAssignment, getAssignmentDefaults, getStudentReviewFeedback } from '../../../queries/admin-queries';
import Button from '../../../components/button/button';
import Loading from '../../../components/loading/loading';
import Navigation from '../../../components/navigation/navigation';
import ScrollArea from '../../../components/scroll-area/scroll-area';
import styles from '../../student/results/results.scss';
import ReactHtmlParser from 'react-html-parser';

const buttonClasses = classNames("rounded py-2 px-4 text-lg text-white bg-blue-500 hover:bg-blue-700 cursor-pointer");

const ShowReview = (props) => {
  const { feedback, index } = props;

  let classes = classNames(
    "my-4 p-4 border border-gray-600 hover:cursor-pointer",
  );

  return (
    <div className={classes}>
      <h3 className="my-2 font-bold">#{index + 1} Feedback</h3>
      {feedback.qualitative.map((qualitative, i) => (
        <>
          <p className="my-2 font-bold">{qualitative.label}</p>
          <p className="my-2">{qualitative.answer}</p>
        </>
      ))}
      {!feedback.qualitative.length && <p className="my-2">No qualitative text questions in this assignment's score feedback</p>}
    </div>
  )
}

const DisplayComparativeReviews = (props) => {
  const { result, index, chosen, toggleChosen } = props;
  let isChosen = false;
  if (chosen == result.id) {
    isChosen = true;
  }

  let classes = classNames(
    "my-4 p-4 border border-gray-400",
    { "bg-gray-200": !isChosen },
    { "bg-blue-200": isChosen },
    { "hover:bg-gray-300": !isChosen },
  );

  return (
    <div className={classes} onClick={() => toggleChosen(result.id)}>
      <h2 className="text-xl font-bold">Review #{index + 1}</h2>
      {isChosen && <div className="my-4">
        <div className="my-4 p-4 bg-blue-100">
          {result.qualitative.map((qualitative, i) => (
            <>
              <p className="my-2 font-bold">{qualitative.label}</p>
              <p className="my-2">{qualitative.answer}</p>
            </>
          ))}
        </div>
        {result.feedbacks.map((feedback, i) => (
          <ShowReview key={i} feedback={feedback} index={i} />
        ))}
      </div>}
    </div>
  )
}

const StudentFeedbackResults = (props) => {
  const { id, sectionMemberID } = useParams();
  const history = useHistory();
  const [chosen, setChosen] = useState(null);
  const user = useQuery('me', getMe, userQuerySettings);
  const assignment = useQuery(['admin-assignment', id], () => getAssignment(id), getAssignmentDefaults);
  const results = useQuery(['admin-student-results-feedback', id, sectionMemberID], () => getStudentReviewFeedback(id, sectionMemberID));

  const toggleChosen = (newChoice) => {
    console.log(newChoice);
    if (newChoice === chosen) {
      setChosen(null);
    } else {
      setChosen(newChoice);
    }
  }

  if (results.isError) {
    console.log("ERROR")
  }
  if (user.isLoading || assignment.isLoading || results.isLoading) {
    return <Loading />
  }

  let isMultiple = results.data.length > 1;

  return (
    <div className={styles.container}>
      <ScrollArea>
        <div className={styles.content}>
          <div className={styles.welcome}>
            <h3>
              Compare Their Reviews To Others'
            </h3>
          </div>
          {results.data.length > 0 && (
            <p className="my-4">Click on {isMultiple ? 'each' : 'the'} Review below to view the Review and all Feedback. {isMultiple && (<span>Click it again to close and view another.</span>)}</p>
          )}
          <div className="my-6">
            {results.data.map((result, index) => (
              <DisplayComparativeReviews
                key={index}
                index={index}
                result={result}
                chosen={chosen}
                toggleChosen={toggleChosen}
              />
            ))}
            {!results.data.length && (
              <div className="bg-blue-100 border border-blue-300 p-4">
                <p className="my-2">This student has not yet completed any reviews</p>
              </div>
            )}
          </div>
        </div>
      </ScrollArea>
    </div>
  )
};

export default StudentFeedbackResults;
